module.exports = __webpack_public_path__ + "static/img/product-e10.635950e6.png";